import { createIcon } from '@chakra-ui/icons';

export const Slack = createIcon({
  displayName: 'Slack',
  viewBox: '0 0 18 18',
  path: [
    <svg
      width="18"
      height="18"
      viewBox="80 72 800 816"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g clipPath="url(#clip0_731_1347)">
          <path
            d="M640.301 367.929C672.66 323.584 742.473 360.638 739.577 410.875C739.077 473.197 692.536 477.392 642.298 474.696C614.733 476.493 627.617 381.112 640.301 367.929Z"
            fill="white"
          />
          <path
            d="M635.708 617.116C601.351 617.715 565.896 620.711 532.537 610.624C453.636 582.859 500.377 472.297 574.984 486.679C617.731 487.078 660.977 485.58 703.124 493.87C750.964 501.76 758.754 567.578 724.597 595.343C700.328 617.415 666.17 614.919 635.708 617.116Z"
            fill="white"
          />
          <path
            d="M430.763 355.844C376.73 341.063 316.805 344.858 262.173 354.546C213.334 361.837 192.66 448.329 248.391 466.905C282.548 476.394 318.503 474.796 353.559 476.893C373.634 471.999 402.298 479.789 424.471 472.099C473.409 455.02 485.095 374.621 430.763 355.844ZM337.779 518.441C340.675 489.078 326.992 483.485 300.725 486.381C201.349 472.199 202.947 628.703 300.825 610.826C340.376 598.541 336.88 552.099 337.779 518.441ZM506.368 77.9916C604.945 75.1951 727.791 52.0241 801.699 134.121C881 214.421 865.22 335.67 873.509 439.14C875.407 581.662 916.156 792.498 750.962 859.215C681.549 881.088 607.742 879.989 535.831 885.282C394.009 888.379 201.349 905.357 120.85 761.637C86.1934 680.838 86.5929 590.551 80.3008 505.158C87.8913 129.028 118.153 63.8093 506.368 77.9916ZM642.198 474.696C692.436 477.392 738.977 473.198 739.477 410.875C742.373 360.638 672.66 323.585 640.201 367.929C627.617 381.113 614.733 476.493 642.198 474.696ZM466.418 271.25C464.021 239.59 432.66 223.41 403.197 225.008C326.393 227.605 306.918 346.456 437.055 335.17C481.499 339.864 466.818 299.714 466.418 271.25ZM476.705 537.317C470.713 506.856 437.854 489.277 412.785 488.079C362.948 484.783 347.567 542.91 349.764 583.56C349.065 643.984 342.573 757.442 435.557 738.266C491.087 721.287 472.91 648.179 479.402 603.535C474.808 584.858 480.9 558.291 476.705 537.317ZM574.982 486.581C500.376 472.199 453.534 582.761 532.535 610.526C565.894 620.713 601.35 617.617 635.707 617.018C666.168 614.92 700.426 617.417 724.595 595.245C758.853 567.48 750.963 501.562 703.122 493.772C660.975 485.482 617.729 486.98 574.982 486.581ZM615.831 321.487C617.829 276.144 604.046 216.219 544.72 218.816C521.549 220.513 502.773 231.2 496.181 254.671C486.293 297.617 486.393 342.561 486.094 386.506C471.811 461.612 577.379 511.749 608.64 431.65C620.426 396.194 615.831 358.341 615.831 321.487ZM556.206 739.665C636.306 734.171 648.291 617.018 525.045 628.503C474.009 624.808 492.885 660.763 492.685 695.919C495.881 726.381 528.141 740.963 556.206 739.665Z"
            fill="#000000"
          />
          <path
            d="M608.739 431.748C577.478 511.847 471.91 461.71 486.192 386.604C486.392 342.659 486.392 297.715 496.279 254.769C502.871 231.398 521.648 220.612 544.819 218.914C604.144 216.317 617.927 276.242 615.93 321.585C615.83 358.339 620.424 396.192 608.739 431.748Z"
            fill="white"
          />
          <path
            d="M525.044 628.503C648.29 617.017 636.305 734.171 556.205 739.664C528.14 740.962 495.881 726.48 492.685 695.919C492.884 660.763 474.008 624.808 525.044 628.503Z"
            fill="white"
          />
          <path
            d="M412.784 487.978C437.853 489.177 470.712 506.755 476.705 537.217C480.899 558.19 474.807 584.757 479.401 603.334C472.809 647.878 491.087 721.087 435.556 738.066C342.572 757.341 349.164 643.883 349.763 583.359C347.566 542.81 362.947 484.782 412.784 487.978Z"
            fill="white"
          />
          <path
            d="M403.198 225.109C432.661 223.412 464.022 239.591 466.419 271.352C466.818 299.816 481.5 339.966 436.955 335.372C306.918 346.458 326.394 227.606 403.198 225.109Z"
            fill="white"
          />
          <path
            d="M262.273 354.546C316.904 344.958 376.829 341.063 430.862 355.845C485.194 374.621 473.509 455.021 424.57 472.099C402.398 479.79 373.833 472 353.658 476.893C318.602 474.796 282.647 476.394 248.49 466.906C192.76 448.329 213.434 361.837 262.273 354.546Z"
            fill="white"
          />
          <path
            d="M300.726 486.383C327.093 483.486 340.776 488.98 337.78 518.443C336.881 552.101 340.377 598.543 300.826 610.827C202.948 628.705 201.35 472.3 300.726 486.383Z"
            fill="white"
          />
        </g>

        <defs>
          <clipPath id="clip0_731_1347">
            <rect width="800" height="815.98" fill="white" transform="translate(80 72)" />
          </clipPath>
        </defs>
      </g>
    </svg>,
  ],
});
